document.addEventListener("DOMContentLoaded", event => {

  window.onscroll = () => {
    if (window.pageYOffset > 163) {
      document.getElementById('to_top').style.opacity = 1
    } else {
      document.getElementById('to_top').style.opacity = 0
    }
  }

  document.getElementById('to_top').addEventListener('click', event => {
    event.preventDefault()
    window.scrollTo(0, 0)
  })

  document.querySelectorAll('a[rel=external]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault()
      window.open(event.currentTarget.href)
    })
  })

})
